import THEME from './default_theme';

export default THEME;
